import { createFileRoute } from "@tanstack/react-router";
import OcdKetaminePage from "@/pages/OcdKetaminePage";
import { buildConditionSchema } from "@/components/ConditionPageLayout";
export const Route = createFileRoute("/ocd-treatment-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Ocd Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "OCD treatment in Coral Springs, FL. Therapy, medication management, and supportive care for obsessive-compulsive disorder at Neuro Wellness TMS.",
        },
        {
          property: "og:title",
          content: "Ocd Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "OCD treatment in Coral Springs, FL. Therapy, medication management, and supportive care for obsessive-compulsive disorder at Neuro Wellness TMS.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/ocd-treatment-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/ocd-treatment-coral-springs-fl",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildConditionSchema({
              seoTitle:
                "Ketamine for OCD Treatment Coral Springs, FL | Neuro Wellness TMS Centers of America",
              seoDescription:
                "Rapid relief from obsessive thoughts and compulsive behaviors with IV Ketamine therapy at Neuro Wellness TMS Centers in Coral Springs, FL.",
              canonical: "/ocd-treatment-coral-springs-fl",
              breadcrumbs: [
                { name: "Services", href: "/services-directory" },
                {
                  name: "Conditions Treated",
                  href: "/ketamine-treatment-coral-springs-fl",
                },
                { name: "OCD", href: "/ocd-treatment-coral-springs-fl" },
              ],
            }),
          ),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <OcdKetaminePage />;
}
